export default __webpack_public_path__ + "static/media/checked_primary3.f219179e.svg";